import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserRoleDegradeService } from './user-role-degrade.service';

@Component({
  selector: 'app-user-role-degrade',
  templateUrl: './user-role-degrade.component.html',
  styleUrls: ['./user-role-degrade.component.scss']
})
export class UserRoleDegradeComponent implements OnInit {
    public modalOpen: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private _userRoleDegradeService: UserRoleDegradeService,


      ) { }

      ngOnInit() {
        this._userRoleDegradeService.modal.subscribe(isOpen => {
            // console.log("i received to open modal ?", isOpen);
            this.modalOpen = isOpen as boolean;
        });

      }
      closeModal() {
        this._userRoleDegradeService.close();
        this.activeModal.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/app/user-role-degrade/user-role-degrade.component.ts